import { URLS } from 'services/urls';

const ProductPanel = () => (
    <div className="DirectSignUp__ProductPanel" data-testid="product-panel">
        <img
            className="DirectSignUp__ProductPanelBg"
            src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/bg_buildings.png')}
            alt=""
            aria-hidden
        />
        <div className="DirectSignUp__ProductPanelContent">
            <img
                className="DirectSignUp__ProductScreenshot"
                src={URLS.IMAGE_CLOUDFRONT_URL('deal/signup/pro_forma_example.png')}
                alt="Northspyre Deal product screenshot"
            />
            <div className="DirectSignUp__SocialProof">
                <p className="DirectSignUp__SocialProofHeadline">300+</p>
                <p className="DirectSignUp__SocialProofBody">
                    Development teams have stopped building pro formas from scratch.
                </p>
            </div>
        </div>
    </div>
);

export default ProductPanel;
